/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormButtonOnSaveModel
 */
export interface FormButtonOnSaveModel {
    /**
     * 
     * @type {boolean}
     * @memberof FormButtonOnSaveModel
     */
    loadEditFormInline?: boolean;
}

/**
 * Check if a given object implements the FormButtonOnSaveModel interface.
 */
export function instanceOfFormButtonOnSaveModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormButtonOnSaveModelFromJSON(json: any): FormButtonOnSaveModel {
    return FormButtonOnSaveModelFromJSONTyped(json, false);
}

export function FormButtonOnSaveModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormButtonOnSaveModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'loadEditFormInline': !exists(json, 'loadEditFormInline') ? undefined : json['loadEditFormInline'],
    };
}

export function FormButtonOnSaveModelToJSON(value?: FormButtonOnSaveModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'loadEditFormInline': value.loadEditFormInline,
    };
}

